import * as React from 'react';

import {Dropdown} from '../../dropdown/dropdown';
import {TooltipButton} from '../../tooltip-button/tooltip-button';
import {ConfirmModal} from '../../confirm-modal';
import {SessionEditorToggle} from '../toggle/toggle';
import {languages, ILanguage} from '../data';

import './styles.sass';

export interface ISessionEditorHeaderProps {
  leftBarHidden: boolean;
  connected: boolean;
  children?: any;
  disabled: boolean;
  language: string;

  selectLanguage: (language: string) => void;
  toggleLeftBar: () => void;
  resetCode: () => void;
}

export interface ISessionEditorHeaderState {
  resetCodeConfirmModalShown: boolean;
}

export interface ILanguageOption {
  value: string;
  label: React.ReactElement<any>;
}

export class SessionEditorHeader extends React.Component<ISessionEditorHeaderProps, ISessionEditorHeaderState> {
  public state: ISessionEditorHeaderState = {
    resetCodeConfirmModalShown: false,
  };

  public render(): React.ReactElement<any> {
    const {
      leftBarHidden,
      connected,
      disabled,
      language,

      toggleLeftBar,
      children,
    } = this.props;

    const {resetCodeConfirmModalShown} = this.state;

    return (
      <div className={'session-editor-header'}>
        {leftBarHidden && <SessionEditorToggle onToggle={toggleLeftBar} />}

        <div className={'session-editor-header__controls'}>
          <Dropdown
            value={language}
            label={'Language:'}
            options={languages.map(this.mapLanguage)}
            disabled={!connected || disabled}
            onChange={option => this.selectLanguage(option.value)}
          />

          <TooltipButton
            disabled={!connected || disabled}
            onClick={this.showResetCodeConfirmModal}
            className={'btn btn_xs btn_capitalize btn_black-grey btn_reset'}
            tooltipPlacement={'bottom'}
            tooltipLabel={'Reset code'}
          >
            <span className={'icon icon--reset'} />
            <span className={'btn__label btn__label_left-blank'}>Reset</span>
          </TooltipButton>

          {children}
        </div>

        <ConfirmModal
          isOpen={resetCodeConfirmModalShown}
          onClose={this.closeResetCodeConfirmModal}
          title={'Reset code'}
        >
          <div className={'confirm-modal-component__content'}>
            <p>Resetting the code will lose all current changes.</p>
            <p>Are you sure you want to proceed?</p>
          </div>
        </ConfirmModal>
      </div>
    );
  }

  private showResetCodeConfirmModal = (): void => {
    this.setState({resetCodeConfirmModalShown: true});
  };

  private closeResetCodeConfirmModal = (result: boolean): void => {
    this.setState({resetCodeConfirmModalShown: false});

    if (result) {
      this.props.resetCode();
    }
  };

  private mapLanguage({value, label, icon}: ILanguage): ILanguageOption {
    return {
      value,
      label: <div className={'dropdown-component__item-inner'}>
        <i className={`icon ${icon}`} />{label}
      </div>,
    };
  }

  private selectLanguage = (language: string): void => {
    this.props.selectLanguage(language);
  }
}
